/**
 * API Endpoint Prefixes
 * Centralized version and module prefix management
 */

// API versions
export const API_VERSION = {
  V1: '/v1',
  V2: '/v2',
} as const;

// Module prefixes
export const API_MODULE = {
  ADMIN: '/admin',
  PUBLIC: '/public',
  AGENT: '/agent',
} as const;

// Combined prefixes (commonly used combinations)
export const API_PREFIX = {
  ADMIN_V1: `${API_VERSION.V1}${API_MODULE.ADMIN}`, // /v1/admin
  PUBLIC_V1: `${API_VERSION.V1}${API_MODULE.PUBLIC}`, // /v1/public
  AGENT_V1: `${API_VERSION.V1}${API_MODULE.AGENT}`, // /v1/agent
} as const;
